let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9GZ76")).then(() => parcelRequire('dbbA6'));